export enum ServiceLineType {
    Testing = 'Testing',
    Inspection = 'Inspection',
    Audit = 'Audit',
}
